"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Banner_1 = __importDefault(require("../Banner"));
const Controls_1 = __importDefault(require("../base/Controls"));
const Input_1 = __importDefault(require("../base/Input"));
const Layout_1 = require("../base/Layout");
const Select_1 = __importDefault(require("../base/Select"));
const Text_1 = __importDefault(require("../base/Text"));
const LoadingButton_1 = __importDefault(require("../LoadingButton"));
const CubeSearchController = ({ query = '', order = 'pop', title = null, ascending = false, go, }) => {
    const [queryText, setQuery] = (0, react_1.useState)(query);
    const [searchOrder, setSearchOrder] = (0, react_1.useState)(order);
    const [searchAscending, setSearchAscending] = (0, react_1.useState)(ascending.toString());
    const searchOptions = [
        ['Sorted by Popularity', 'pop'],
        ['Sorted Alphabetically', 'alpha'],
        ['Sorted by Card Count', 'cards'],
    ];
    return (react_1.default.createElement(Controls_1.default, { className: "p-2" },
        react_1.default.createElement(Banner_1.default, null),
        react_1.default.createElement(Text_1.default, { lg: true, bold: true }, title),
        react_1.default.createElement(Layout_1.Row, { xs: 12 },
            react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 3 },
                react_1.default.createElement(Input_1.default, { placeholder: "Search cubes...", value: queryText, onEnter: () => go(queryText, searchOrder, searchAscending), onChange: (event) => setQuery(event.target.value) })),
            react_1.default.createElement(Layout_1.Col, { xs: 6, sm: 3 },
                react_1.default.createElement(Select_1.default, { options: searchOptions.map((search) => ({ value: search[1], label: search[0] })), defaultValue: searchOrder, setValue: (value) => setSearchOrder(value) })),
            react_1.default.createElement(Layout_1.Col, { xs: 6, sm: 3 },
                react_1.default.createElement(Select_1.default, { options: [
                        { value: 'true', label: 'Ascending' },
                        { value: 'false', label: 'Descending' },
                    ], defaultValue: searchAscending, setValue: (value) => setSearchAscending(value) })),
            react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 3 },
                react_1.default.createElement(LoadingButton_1.default, { block: true, color: "primary", onClick: () => go(queryText, searchOrder, searchAscending) },
                    react_1.default.createElement("span", { className: "px-4" }, "Search"))))));
};
exports.default = CubeSearchController;
